/**
 * Invitee role helpers, mirroring the dashboard's EventInviteesService:
 * an invitee is the organizer/creator when their email (case-insensitive)
 * or user id matches the event's organizer/creator fields.
 *
 * Precedence: organizer wins. An invitee who is both organizer and creator
 * is labeled "Organizer" only.
 */
var matchesEmail = function (eventEmail, inviteeEmail) {
    return !!eventEmail &&
        !!inviteeEmail &&
        eventEmail.toLowerCase() === inviteeEmail.toLowerCase();
};
var matchesUserId = function (eventUserId, inviteeUserId) {
    return typeof eventUserId === 'number' &&
        typeof inviteeUserId === 'number' &&
        eventUserId === inviteeUserId;
};
export var isEventOrganizer = function (event, invitee) {
    return matchesEmail(event.organizer_email, invitee.email) ||
        matchesUserId(event.organizer_id, invitee.user_id);
};
export var isEventCreator = function (event, invitee) {
    return matchesEmail(event.creator_email, invitee.email) ||
        matchesUserId(event.creator_id, invitee.user_id) ||
        matchesUserId(event.robin_creator_id, invitee.user_id);
};
/**
 * Returns the display role for an invitee. `isOrganizerFlag` is the
 * API-computed is_organizer flag when available — it takes precedence
 * alongside the email/id match.
 */
export var getInviteeRole = function (event, invitee, isOrganizerFlag) {
    if (isOrganizerFlag || isEventOrganizer(event, invitee)) {
        return 'organizer';
    }
    if (isEventCreator(event, invitee)) {
        return 'creator';
    }
    return null;
};
